<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 11:15:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-17 19:39:14
-->
<template>
  <div class="judge-question">
    <el-form
      ref="judgeForm"
      :model="questionInfo"
      :rules="rules"
      label-width="70px"
      class="judgeForm"
    >
      <el-form-item label="题干:" prop="questionName">
        <tinymce
          ref="editor"
          v-model="questionInfo.questionName"
          height="170"
          width="812"
        ></tinymce>
      </el-form-item>
      <el-form-item label="选项:" prop="rightOptionId">
        <el-button
          v-show="questionInfo.optionList.length < tagList.length"
          class="addBtn"
          icon="el-icon-circle-plus-outline"
          @click="addOption"
        >
          增加选项
        </el-button>
        <div v-show="questionInfo.optionList.length == tagList.length" style="color:#fff">--</div>
        <div class="radio-list">
          <div v-for="(item, index) in questionInfo.optionList" :key="item.id" class="radio-item">
            <el-radio v-model="questionInfo.rightOptionId" :label="item.id">
              <div class="tag">{{ tagList[index].toUpperCase() }}</div>
            </el-radio>
            <tinymce ref="editor" v-model="item.optionName" height="120" width="739"></tinymce>
            <i
              v-show="questionInfo.optionList.length > 1"
              class="el-icon-delete"
              @click="removeOption(index)"
            ></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="解析:" prop="analysis">
        <tinymce key="jud" v-model="questionInfo.analysis" height="170" width="783"></tinymce>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button :loading="saveLoading" type="primary" @click="save">保存</el-button>
      <el-button @click="remove">删除</el-button>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce'
let newOptionId = 1
export default {
  name: 'JudgeQuestion',
  components: { Tinymce },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({
        optionList: [],
      }),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
      rules: {
        questionName: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        rightOptionId: [{ required: true, message: '请选择选项', trigger: 'change' }],
      },
    }
  },
  methods: {
    addOption() {
      if (this.questionInfo.optionList.length >= this.tagList.length) return
      this.questionInfo.optionList.push({
        id: 'new' + newOptionId,
        optionName: '',
      })
      newOptionId++
    },
    removeOption(index) {
      this.questionInfo.optionList.splice(index, 1)
    },
    save() {
      const {
        questionName,
        questionType,
        score,
        optionList,
        rightOptionId,
        analysis,
      } = this.questionInfo
      let optionObj = {}
      optionList.map((item, index) => {
        if (rightOptionId == item.id) {
          optionObj.rightKey = index + 1
        }
        this.$set(optionObj, this.tagList[index], item.optionName)
      })
      let params = {
        questionName,
        questionType,
        score,
        analysis,
        ...optionObj,
      }
      this.$emit('edit', params)
    },
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-form {
  .tox-tinymce {
    width: 820px;
  }
  .el-form-item__label {
    height: 36px;
    line-height: 36px;
  }
  .addBtn {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    i {
      font-size: 16px;
    }
  }
  .radio-list {
    margin-left: -70px;
  }
  .radio-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .el-radio {
      display: flex;
      align-items: center;
      margin-right: 0;
      .el-radio__label {
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
      &.is-checked {
        .el-radio__label {
          .tag {
            background-color: #3671bf;
          }
        }
      }
      .tag {
        border-radius: 50%;
        width: 28px;
        height: 28px;
        background: #c1c8d1;
        color: #fff;
        text-align: center;
        line-height: 28px;
        margin-right: 10px;
      }
    }
    > i {
      cursor: pointer;
      font-size: 16px;
      color: #3671bf;
      margin-left: 20px;
    }
  }
}
</style>
